function contactSelectDirective() {
	return {
		scope : {
			idClient: '=',
			contact: '='
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/contactSelectDirective.html';
		},
		controller : [ '$scope', '$window', 'alertService', 'clientService', function($scope, $window, alertService, clientService) {

			$scope.availableContacts = [];

			$scope.searchContacts = function(query) {
				var filter = {
						name: query
				};
				
				clientService.searchClientContacts($scope.idClient, filter).then(function(response) {
                    $scope.loading = false;
                    var result = response.getData();
                    $scope.availableContacts = result.results;
                }, function(response) {
                    $scope.loading = false;
                });
				
			};

		} ],
		link : function(scope, elem, attr) {
			
		}
	};
};

module.directive('contactSelect', [ contactSelectDirective ]);